import React, { useCallback, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { generatePath, useHistory, useLocation, useParams } from 'react-router-dom';
import {
  FormCard,
  YupDate,
  YupNumeric,
  YupString,
  isNumeric,
} from 'motion-components';
import * as Yup from 'yup';
import * as Lo from 'lodash';
import { gqlGetByIdQuery } from '../graphql';
import { FormFields } from './form-fields';
import { useTranslation } from 'react-i18next';
import { useHandleError } from 'shared-pages/services';
import { getRouteByName } from 'app/routes';

export const EMailsRepoFormPage = () => {
  const { t } = useTranslation();
  const { handleGraphqlError } = useHandleError('EMailsRepoFormPage');
  const history = useHistory();
  const location = useLocation<any>();
  const { id } = useParams<{ id: string }>();
  const idNum = isNumeric(id) ? parseInt(id, 10) : -1;

  const formShape = {
    id: YupNumeric,
    originatedFrom: YupString,
    from: YupString,
    to: YupString,
    cc: YupString,
    subject: YupString,
    text: YupString,
    html: YupString,
    composedDate: YupDate,
    sendDate: YupDate,
    failedDate: YupDate,
    failedReason: YupString,
    failedDetails: YupString,
    isDeleted: YupNumeric,
  };

  const validationSchema = Yup.object().shape(formShape);
  const pickProperties = (values) => Lo.pick(values, Lo.keys(formShape));

  const [get, { data: rawData, error, loading }] = useLazyQuery(gqlGetByIdQuery, {
    fetchPolicy: 'network-only',
  });
  const data = rawData?.getMailsrepoById;

  useEffect(() => {
    get({ variables: { id: idNum } });
  }, [get, idNum]);

  /** Ανανεώνει την καρτέλα μετά από επαναφορά ή επαναποστολή */
  const handleRestored = useCallback(() => {
    get({ variables: { id: idNum } });
  }, [get, idNum]);

  /** Επιστροφή στο grid ή στην προηγούμενη οθόνη (π.χ. ενημέρωση) */
  const handleReturn = useCallback(() => {
    if (location.state?.pathname) {
      history.push({ pathname: location.state.pathname, state: location.state });
    } else {
      history.push(generatePath(getRouteByName('Mails')));
    }
  }, [history, location.state]);

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  }

  return (
    <FormCard
      title={`${t('E-mail')}: ${data?.subject ?? ''}`}
      onSubmit={() => undefined}
      onReturn={handleReturn}
      permitSubmit={false}
      permitDelete={false}
      noButtons
      initialValues={pickProperties(data)}
      validationSchema={validationSchema}
      enableReinitialize
      idx={idNum}
      loading={loading && !data}
    >
      <FormFields data={data} onRestored={handleRestored} />
    </FormCard>
  );
};
